export default "__VITE_ASSET__da455c63__"